// extracted by mini-css-extract-plugin
export default {"container":"profilePage_container__vCdQg","details":"profilePage_details__Jqfry"};